import { isNil } from 'lodash'
import type {
    Contact,
    CreateOrUpdateDebtorContact,
    CreateOrUpdateDebtorContactGateway,
    Debtor,
    Identifier
} from '@/shared/models/debtorModels'
import { replaceItemAtIndex } from './arrayUtils'
import { removeEmailWhitespace } from './inputUtils'

export const mapCreateOrUpdateDebtorContacts = (
    payload: CreateOrUpdateDebtorContact
): CreateOrUpdateDebtorContactGateway => {
    const contacts = payload.contacts?.map((contact) => removeEmailWhitespace(contact)) ?? []
    const newContact = removeEmailWhitespace(payload.contact)
    const isNewContact = isNil(contacts.find((contact) => contact.email === newContact.email))
    if (isNewContact) {
        return {
            country: payload.country,
            identifier: payload.identifier,
            name: payload.name,
            contacts: [...contacts, newContact]
        }
    }

    const indexToUpdate = contacts.findIndex((contact) => contact.email === newContact.email)
    const updatedContacts = replaceItemAtIndex(contacts, indexToUpdate, newContact)

    return {
        country: payload.country,
        identifier: payload.identifier,
        name: payload.name,
        contacts: updatedContacts
    }
}

const getFlagEmoji = (countryCode: string | undefined): string => {
    if (!countryCode) return ''
    const codePoints = countryCode
        .toUpperCase()
        .split('')
        .map((char) => 127397 + char.charCodeAt(0)) // Convert to regional indicator symbols
    return String.fromCodePoint(...codePoints)
}
export const getDebtorDisplayName = (
    debtorName: Debtor['name'] | undefined,
    debtorIdentifier: Identifier | undefined | null
): string => {
    if (debtorName) {
        return debtorName
    }
    return displayFormattedIdentifier(debtorIdentifier)
}

export const displayFormattedIdentifier = (identifier: Identifier | undefined | null): string => {
    if (isNil(identifier)) {
        return '-'
    }
    const { value, type, country } = identifier
    const flagEmoji = getFlagEmoji(country)
    return `${value} (${type.toUpperCase()}) ${flagEmoji}`
}

export const cleanContact = (contact: Contact): Contact => {
    const { email, firstName, lastName, phoneNumber, position } = contact
    return { email, firstName, lastName, phoneNumber, position }
}
